import { render } from "./SettingVarious.vue?vue&type=template&id=74ff4007&scoped=true&ts=true"
import script from "./SettingVarious.vue?vue&type=script&lang=ts"
export * from "./SettingVarious.vue?vue&type=script&lang=ts"

import "./SettingVarious.vue?vue&type=style&index=0&id=74ff4007&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ff4007"]])

export default __exports__